import React, { Component } from "react";
import { Button, Icon } from "semantic-ui-react";
import DeleteAxios from "../axiosComponent/delete";
import ConfirmationModal from "./confirmationModal";
import { deleteSuccess } from "../../utils/constant";

export class ActionButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDelete: false,
    };
  }

  setisDelete = (status) => {
    this.setState({ isDelete: status });
  };

  deleteRowDataById = () => {
    let vendor_id = +localStorage.getItem("vendorId")
    let availability_id = this.props.data.availability_id
    const userName = this.props.data.username;
    delete this.props.data.username
    this.props.data.userName = userName
    let obj = this.props.agGridReact.props.completeURL
      ? {
        completeURL: `${this.props.agGridReact.props.completeURL}/${this.props.data[this.props.agGridReact.props.keyIndex]
          }`,
        payload: { ...this.props.data },
      }
      : (this.props.agGridReact.props.deleteURL ?
        {
          completeURL: `${this.props.agGridReact.props.deleteURL}` + availability_id + `/vendor/` + vendor_id,
          payload: { ...this.props.data },
        }
        :
        {
          url: this.props.agGridReact.props.baseURL === 'branchMaster' ? "branch" : this.props.agGridReact.props.baseURL,
          uniqueId: this.props.data[this.props.agGridReact.props.keyIndex],
          payload: { ...this.props.data },
        });
    DeleteAxios(obj)
      .then((res) => {
        let alert = {
          type: "success",
          messageHeader: "Success",
          messageBody: deleteSuccess,
        };
        this.props.agGridReact.props.onDelete(alert);
      })
      .catch((err) => {
        console.log("err", err);
        let alert = {
          type: "error",
          messageHeader: "Error",
          messageBody: err.data.message,
        };
        this.props.agGridReact.props.onDelete(alert);
      });
  };

  handleOpenDelete = () => {
    this.setisDelete(true);
  };

  handleCancel = () => {
    this.setisDelete(false);
  };

  handleConfirm = () => {
    this.setisDelete(false);
    this.deleteRowDataById();
  };

  render() {
    return (
      <>
        {!this.props.agGridReact.props.hideRowEdit && (
          <Button
            onClick={() => this.props.agGridReact.props.onEdit(this.props.data)}
            basic
            size="mini"
            type="button"
            icon
          >
            {" "}
            <Icon name="pencil" color="green" />
          </Button>
        )}
        {!this.props.agGridReact.props.hideRowDelete && (
          <Button
            onClick={this.handleOpenDelete}
            basic
            size="mini"
            type="button"
            icon
          >
            {" "}
            <Icon name="trash" color="red" />
          </Button>
        )}
        {this.state.isDelete && (
          <ConfirmationModal
            open={this.state.isDelete}
            handleCancel={this.handleCancel}
            handleConfirm={this.handleConfirm}
          />
        )}
      </>
    );
  }
}

export default ActionButton;
